import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'nallian-shared-ui/lib/components';
import { withTranslation } from 'react-i18next';
import {
  FieldComponent,
  SelectFieldValueComponent,
} from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import { compose } from 'redux';
import vehicleTypesService from '../services/vehicleTypesService';
import CountriesSelect from '../../app/components/CountriesSelect';
import OwnerField from './OwnerField';

const VehicleFormFields = ({
  submitProcessing,
  dataLoading,
  getVehicleTypesForSelectOptionsWithoutUnknown,
  vehicleTypesFetch,
  t,
}) => (
  <Fragment>
    <Field
      label={t('country')}
      placeholder={t('country')}
      name="countryCode"
      component={FieldComponent}
      valueComponent={CountriesSelect}
      disabled={submitProcessing || dataLoading}
      lazyLoad
      search
      autoFocus
    />
    <Field
      label={t('type')}
      placeholder={t('type')}
      name="typeId"
      component={FieldComponent}
      valueComponent={SelectFieldValueComponent}
      options={getVehicleTypesForSelectOptionsWithoutUnknown()}
      disabled={submitProcessing || dataLoading}
      loading={!!vehicleTypesFetch.pending}
      lazyLoad
      search
    />
    <Field
      label={t('owner')}
      component={FieldComponent}
      valueComponent={OwnerField}
      name="owner"
      disabled={submitProcessing || dataLoading}
    />
  </Fragment>
);

export const validateVehicleFormFields = (values, t) => {
  const errors = {};

  if (values.typeId === undefined) {
    errors.typeId = t('selectVehicleTypeErr');
  }

  if (!values.countryCode) {
    errors.countryCode = t('selectCountryErr');
  }

  if (!values.owner || (!values.owner.ownedById && !values.owner.owner)) {
    errors.owner = t('noOwnerErr');
  }

  return errors;
};

VehicleFormFields.propTypes = {
  t: PropTypes.func.isRequired,
  dataLoading: PropTypes.bool,
  submitProcessing: PropTypes.bool,
  getVehicleTypesForSelectOptionsWithoutUnknown: PropTypes.func.isRequired,
  vehicleTypesFetch: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

VehicleFormFields.defaultProps = {
  dataLoading: false,
  submitProcessing: false,
};

export default compose(
  withTranslation(),
  vehicleTypesService
)(VehicleFormFields);
